import React, { useState } from 'react';
import '../css/filtro.css';
import OfertaDemanda from './OfertaDemanda';
import { ContainerFiltros } from './ContainerFiltros';

function Filtros(props) {
    const [badgesRubro, setBadgesRubro] = useState([]);
    const [badgesOferta, setBadgesOferta] = useState([]);
    const [badgesDemanda, setBadgesDemanda] = useState([]);

    function cerrarFiltros() {
        document.getElementById("containerFiltros").classList.add("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.add("ocultarFiltros")
    }
    function filtrar() {
        props.seleccionarEmpresas(true, badgesOferta, badgesDemanda, badgesRubro)
    }
    function quitarFiltros() {
        setBadgesDemanda([])
        setBadgesOferta([])
        setBadgesRubro([])
        props.seleccionarEmpresas(true, [], [], [])
    }

    return (
        <>  {/* 
            <div id="containerFiltros" className='container text-start bg-white 
            position-fixed end-0 top-0 bottom-0 z-1050 px-5 containerFiltros ocultarFiltros py-5'>
                <h1 id="encabezado" className='pb-4 titulos'>Filtros</h1>       
                <button type="button" id='btnCloseFiltro' class="btn-close btn-close-modal " 
                aria-label="Close" onClick={cerrarFiltros}></button>              
                <OfertaDemanda setBadgesOferta={setBadgesOferta} badgesOferta={badgesOferta}  
                badgesDemanda={badgesDemanda}  setBadgesDemanda={setBadgesDemanda} 
                badgesRubro={badgesRubro} setBadgesRubro={setBadgesRubro} filtro={true}/>
                <div className='text-center'>
                    <button class="btn me-3 mt-5 btn-outline-primary bold-botones"
                    type="submit" onClick={quitarFiltros}>Remover Filtros</button>
                    <button class="btn ms-sm-3 mt-sm-5 mt-3 colorPrincipal text-white bold-botones"
                    type="submit" onClick={filtrar}>Filtrar</button>
                </div>
            </div>*/}
            <ContainerFiltros mainContent={<OfertaDemanda setBadgesOferta={setBadgesOferta} badgesOferta={badgesOferta}
                badgesDemanda={badgesDemanda} setBadgesDemanda={setBadgesDemanda}
                badgesRubro={badgesRubro} setBadgesRubro={setBadgesRubro} filtro={true} />}
                quitarFiltros={quitarFiltros} filtrar={filtrar}
            />
        </>
    );
}


export default Filtros;